import {ReactNode} from 'react';

import {Grid} from '@mui/material';

import {pdfPrintPage} from '../styles';

interface Props {
  children: ReactNode;
  hasFollowingPage?: boolean;
}

export const AppendixPageSlot = ({children, hasFollowingPage = false}: Props) => {
  if (children == null) {
    return null;
  }

  return (
    <Grid
      sx={{
        ...pdfPrintPage,
        ...(hasFollowingPage ? {breakAfter: 'page'} : {}),
      }}
    >
      {children}
    </Grid>
  );
};
